import React from 'react'
import { Box, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useGetLanguageMapperGif } from '../../guided-tour-gifs/use-get-language-gif'

/** Charging cards link 3 menu options step component */
export const LinkChargingCardMenuStep: React.FC = () => {
  const { t } = useCustomTranslation()

  const { linkChargingCardMenuGif } = useGetLanguageMapperGif()

  return (
    <Box>
      <Typography>{t('emobility.tour.charging-cards-link-card-menu-option')}</Typography>

      <Typography mt={2}>{t('emobility.tour.charging-cards-dialog-link-title')}</Typography>

      <Box mt={4} display="flex" justifyContent="left" alignItems="left">
        <Box component={'img'} width={'100%'} src={linkChargingCardMenuGif} />
      </Box>
    </Box>
  )
}
